<template>
  <div v-if="Object.keys(invoice_info).length > 0" class="invoice_info">
    <div class="invoice_info__left">
      <div class="invoice_info__left__wrap" ref="content">
        <div class="main_info" ref="main_info">
          <div class="line row">
            <div class="col-md-2 col-sm-2">
              <fg-input v-model="invoice_info.date_period" type="text" :label="translate('invoice.reporting_period')"
                        :placeholder="translate('invoice.reporting_period')" :readonly="true"/>
            </div>

            <div class="col-md-3 col-sm-3 form-group">
              <WrapDatePicker
                  type="date"
                  value_type="YYYY-MM-DD"
                  :placeholder="translate('invoice.date_act')"
                  :label="translate('invoice.date_act')"
                  v-model="invoice_info.date_act"
                  :disabled_date="disabled_date_act"
                  :range="false"
                  :confirm="false"
              />
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="invoice_info.date_create" type="text" :label="translate('invoice.date_create')"
                        :placeholder="translate('invoice.date_create')" :readonly="true"/>
            </div>

            <div class="col-md-2 col-sm-2">
              <fg-input v-model="invoice_info.invoice_number" type="text" :label="translate('invoice.invoice_number')"
                        :placeholder="translate('invoice.invoice_number')" :readonly="true"/>
            </div>

            <div class="col-md-2 col-sm-2">
              <fg-input v-model="sum_in_rub" type="text" :label="translate('invoice.period_sum_with_vat')"
                        :placeholder="translate('invoice.period_sum_with_vat')" :readonly="true"/>
            </div>
          </div>

          <div class="line row">
            <div class="col-md-4 col-sm-4">
              <router-link :to="'/client/' + invoice_info.client_id" class="link">
                <fg-input v-model="invoice_info.client_name" type="text" :label="translate('invoice.client_name')"
                          :placeholder="translate('invoice.client_name')" :readonly="true" />
              </router-link>
            </div>

            <div class="col-md-4 col-sm-4">
              <fg-input v-model="invoice_info.invoice_name" type="text" :label="translate('invoice.invoice_name')"
                        :placeholder="translate('invoice.invoice_name')" :readonly="true"/>
            </div>

            <div class="col-md-4 col-sm-4">
              <fg-input v-model="new_status" type="text" :label="translate('invoice.validation_status')"
                        :placeholder="translate('invoice.validation_status')" :readonly="true"/>
            </div>
          </div>

          <div class="line row">
            <div class="col-md-3 col-sm-3">
              <fg-input v-model="new_payment_status" type="text" :label="translate('invoice.payment_status')"
                        :placeholder="translate('invoice.payment_status')" :readonly="true"/>
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="invoice_info.date_payment" type="text" :label="translate('invoice.date_payment')"
                        :placeholder="translate('invoice.date_payment')" :readonly="true"/>
            </div>

            <div class="col-md-6 col-sm-6" v-if="invoice_info.report_template_filename">
              <fg-input v-model="invoice_info.report_template_filename" type="text" :label="translate('invoice.report_template_filename')"
                        :placeholder="translate('invoice.report_template_filename')" :readonly="true"/>
            </div>
          </div>

          <div class="line row">
            <div class="col-md-3 col-sm-3">
              <fg-input :value="invoice_info.type_title" type="text" :label="translate('invoice.type')"
                        :placeholder="translate('invoice.type')" :readonly="true"/>
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input :value="translate(invoice_info.is_correction ? 'yes' : 'no')" type="text" :label="translate('invoice.is_correction')"
                        :placeholder="translate('invoice.is_correction')" :readonly="true"/>
            </div>
          </div>
        </div>

        <div class="line text-center buttons">
          <span
              v-if="has_changes"
              class="btn btn-success btn-fill btn-wd"
              @click.prevent="edit_invoice"
          >
            {{ translate('btn.edit') }}
          </span>

          <span
              v-if="invoice_info.payment_status === null && invoice_info.validation_status === 1"
              class="btn btn-success btn-fill btn-wd"
              @click.prevent="modal_issue_invoice"
          >
            {{ translate('invoice.issue_an_invoice') }}
          </span>

          <span
              v-if="invoice_info.validation_status === 0"
              class="btn btn-warning btn-fill btn-wd"
              @click.prevent="update_invoice_status(1)"
          >
            {{ translate('invoice.invoice_is_correct') }}
          </span>
        </div>
      </div>

      <div class="response_table" ref="prev_invoices" v-if="invoice_info.prev_invoices?.length > 0">
        <div class="table_header">
          <label>{{ translate('invoice.prev_invoices') }}</label>

          <router-link :to="'/invoice_list/list?client_ids=' + invoice_info.client_id">
            <button class="btn-info btn-fill btn-wd">
              {{ translate('invoice.client_invoices') }}
            </button>
          </router-link>
        </div>

        <table>
          <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th class="" scope="col">
              {{ translate('invoice.reporting_period') }}
            </th>
            <th class="" scope="col">
              {{ translate('invoice.invoice_number') }}
            </th>
            <th class="" scope="col">
              {{ translate('invoice.device_count') }}
            </th>
            <th class="" scope="col">
              {{ translate('invoice.period_sum_with_vat') }}
            </th>
            <th class="" scope="col">
              {{ translate('invoice.payment_status') }}
            </th>
            <th class="" scope="col">
              {{ translate('invoice.date_payment') }}
            </th>
          </tr>
          </thead>
          <tbody>
            <router-link
                v-for="(invoice, key) in invoice_info.prev_invoices"
                :key="key"
                :to="'/invoice/' + invoice.id"
            >
              <tr class="prev_invoice__item">
                <td :data-label="translate('invoice.reporting_period')" >
                  {{ invoice.date }}
                </td>
                <td :data-label="translate('invoice.invoice_number')" >
                  {{ invoice.invoice_number }}
                </td>
                <td :data-label="translate('invoice.device_count')" >
                  {{ invoice.device_count }}
                </td>
                <td :data-label="translate('invoice.period_sum_with_vat')"
                    :class="invoice_info.sum_with_vat === invoice.sum_with_vat ? 'good_sum' : ''"
                    :title="invoice_info.sum_with_vat === invoice.sum_with_vat ? `Сумма совпадает с суммой за ${invoice_info.date_period}` : ''"
                >
                  {{ (invoice.sum_with_vat / 100).toFixed(2) }}
                </td>
                <td :data-label="translate('invoice.payment_status')">
                  <span v-if="get_payment_status(invoice.payment_status) === null"></span>
                  <span v-else class="badge" :style="'background-color: ' + get_payment_status(invoice.payment_status).color">
                    {{ get_payment_status(invoice.payment_status).descr }}
                  </span>
                </td>
                <td :data-label="translate('invoice.date_payment')" >
                  {{ invoice.date_payment }}
                </td>
              </tr>
            </router-link>
          </tbody>
        </table>
      </div>

      <div class="response_table invoice_details" ref="info_devices">
        <div class="table_header">
          <label>{{ translate('invoice.details', {count: invoice_info.devices?.length > 0 ? invoice_info.devices?.length : 0} ) }}</label>
          <div class="buttons">
            <button
                v-if="invoice_info.devices?.length > 0"
                class="btn-info btn-fill btn-wd"
                @click.prevent="download_details"
            >
              {{ translate('invoice.download_details') }}
            </button>
            <button
                v-if="invoice_info.devices?.length > 0"
                class="btn-success btn-fill btn-wd"
                @click.prevent="open_copy_settings"
            >
              {{ translate('invoice.copy_info_in_buffer') }}
            </button>
          </div>
        </div>

        <table>
          <thead style="min-height: 50px; flex:0; display: inline-block">
            <tr>
              <th class="w3per" scope="col">
                №
              </th>
              <th
                  class="pointer w4per"
                  @click="change_filter('device_tariffication_status')"
                  :class="{ selected: filter_type === 'device_tariffication_status' }"
                  scope="col"
              >
                {{ translate('invoice.tariffication_status') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer w10per"
                  @click="change_filter('device_fid')"
                  :class="{ selected: filter_type === 'device_fid' }"
                  scope="col"
              >
                {{ translate('invoice.device_fid') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer w14per"
                  @click="change_filter('device_name')"
                  :class="{ selected: filter_type === 'device_name' }"
                  scope="col"
              >
                {{ translate('invoice.device_name') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>

              <th
                  class="pointer w7per"
                  @click="change_filter('order')"
                  :class="{ selected: filter_type === 'order' }"
                  scope="col"
              >
                {{ translate('invoice.order') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer w8per"
                  @click="change_filter('service_title')"
                  :class="{ selected: filter_type === 'service_title' }"
                  scope="col"
              >
                {{ translate('invoice.service_title') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer w7per"
                  @click="change_filter('price_without_vat')"
                  :class="{ selected: filter_type === 'price_without_vat' }"
                  scope="col"
              >
                {{ translate('invoice.monthly_cost_without_vat') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>

              <th
                  class="pointer w7per"
                  @click="change_filter('price_with_vat')"
                  :class="{ selected: filter_type === 'price_with_vat' }"
                  scope="col"
              >
                {{ translate('invoice.monthly_cost_with_vat') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer w7per"
                  @click="change_filter('period_start')"
                  :class="{ selected: filter_type === 'period_start' }"
                  scope="col"
              >
                {{ translate('invoice.period_start') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>

              <th
                  class="pointer w7per"
                  @click="change_filter('period_end')"
                  :class="{ selected: filter_type === 'period_end' }"
                  scope="col"
              >
                {{ translate('invoice.period_end') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer w3per"
                  @click="change_filter('period_days')"
                  :class="{ selected: filter_type === 'period_days' }"
                  scope="col"
              >
                {{ translate('invoice.period_days') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer w7per"
                  @click="change_filter('sum_without_vat')"
                  :class="{ selected: filter_type === 'sum_without_vat' }"
                  scope="col"
              >
                {{ translate('invoice.period_sum_without_vat') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer w7per"
                  @click="change_filter('sum_with_vat')"
                  :class="{ selected: filter_type === 'sum_with_vat' }"
                  scope="col"
              >
                {{ translate('invoice.period_sum_with_vat') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer w7per"
                  @click="change_filter('vat_amount')"
                  :class="{ selected: filter_type === 'vat_amount' }"
                  scope="col"
              >
                {{ translate('invoice.vat_amount') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th class="w3per" v-if="$store.getters.getPermissions.permissionGod === true"></th>
            </tr>
          </thead>
          <tbody>
          <tr v-for="(device, key) in device_list" :key="key" class="device_item">
            <td :data-label="translate('invoice.id')" class="w3per">
              {{ key + 1 }}
            </td>
            <td :data-label="translate('invoice.tariffication_status')" class="w4per">
              <span
                  v-if="device.device_tariffication_status"
                  class="mdi mdi-currency-rub problem_device tariffication"
              />
            </td>
            <td :data-label="translate('invoice.device_fid')" class="w10per">
              <router-link :to="{path: '/device/' + device.device_fid}">
                {{ device.device_fid }}
              </router-link>
            </td>
            <td :data-label="translate('invoice.device_name')" class="w14per">
              {{ device.device_name }}
            </td>
            <td :data-label="translate('invoice.order')" class="w7per">
              {{ device.order }}
            </td>
            <td :data-label="translate('invoice.service_title')" class="w8per">
              {{ device.service_title }}
            </td>
            <td :data-label="translate('invoice.monthly_cost_without_vat')" class="w7per">
              {{ device.price_without_vat }} {{ device.cost_currency }}
            </td>
            <td :data-label="translate('invoice.monthly_cost_with_vat')" class="w7per">
              {{ device.price_with_vat }} {{ device.cost_currency }}
            </td>
            <td :data-label="translate('invoice.period_start')" :class="!isPeriodStartMatch(invoice_info.date_period, device.period_start) ? 'not_match' : ''" class="w7per">
              {{ device.period_start }}
            </td>
            <td :data-label="translate('invoice.period_end')" :class="!isPeriodEndMatch(invoice_info.date_period, device.period_end) ? 'not_match' : ''" class="w7per">
              {{ device.period_end }}
            </td>
            <td :data-label="translate('invoice.period_days')" :class="!isPeriodDaysCountMatch(invoice_info.date_period, device.period_days) ? 'not_match' : ''" class="w3per">
              {{ device.period_days }}
            </td>
            <td :data-label="translate('invoice.period_sum_without_vat')" :class="Number(device.sum_without_vat) !== Number(device.price_without_vat) ? 'not_full_cost' : ''" class="w7per">
              {{ device.sum_without_vat }}
            </td>
            <td :data-label="translate('invoice.period_sum_with_vat')" :class="Number(device.sum_with_vat) !== Number(device.price_with_vat) ? 'not_full_cost' : ''" class="w7per">
              {{ device.sum_with_vat }}
            </td>
            <td :data-label="translate('invoice.vat_amount')" class="w7per">
              {{ device.vat_amount }}
            </td>
            <td :data-label="translate('invoice.edit_details')" class="w3per" v-if="$store.getters.getPermissions.permissionGod === true">
              <span class="mdi mdi-pen" @click="edit_details(device)"></span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

    </div>

    <div class="invoice_info__right">
      <Summary type="invoice" :info="invoice_info" :view_history="false" />
    </div>
  </div>

</template>
<script>
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";
import Summary from "components/UIComponents/Summary/Summary.vue";
import CopySettings from "./Modal/CopySettings.vue";
import EditDetails from "./Modal/EditDetails.vue";
import IssueAnInvoice from "./Modal/IssueAnInvoice.vue";

const fields_to_check = ["date_act"];

export default {
  name: 'InvoiceInfo',
  components: {
    WrapDatePicker,
    Summary
  },

  props: {
    invoice: {
      type: Object,
      required: true
    },
  },

  data() {
    return {
      invoice_info: {},
      filter_type: "",
      filter_asc: "asc"
    }
  },

  created() {
    this.invoice_info = JSON.parse(JSON.stringify(this.invoice))
  },

  activated() {
    this.invoice_info = JSON.parse(JSON.stringify(this.invoice))
  },

  computed: {
    device_list(){
      let device_list = [...this.invoice_info.devices || []];
      return device_list.sort(this.compareNumbers);
    },
    disabled_date_act(){
      let date = []
      const date_act = this.invoice_info.date_act
      if (this.invoice_info.date_act){
        date = [
          this.getDateYYYMMDD((new Date(date_act)).setMonth(new Date(date_act).getMonth() - 1) / 1000),
          this.getDateYYYMMDD((new Date(date_act)).setMonth(new Date(date_act).getMonth() + 1) / 1000)
        ]
      } else {
        date = ['- 1 month', '+ 1 month']
      }
      return date
    },
    has_changes() {
      let invoice_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.invoice_info[key];
        return obj;
      }, {});

      let invoice = fields_to_check.reduce((obj, key) => {
        obj[key] = this.invoice[key];
        return obj;
      }, {});

      return JSON.stringify(invoice_info) !== JSON.stringify(invoice);
    },
    new_payment_status(){
      let status = this.$store.getters.getClientInvoicesInfo.payment_statuses.find((stat) => {
        if (stat.id === this.invoice_info.payment_status) return stat
      })
      return status ? status.descr : ""
    },
    new_status(){
      let status = this.$store.getters.getClientInvoicesInfo.validation_statuses.find((stat) => {
        if (stat.id === this.invoice_info.validation_status) return stat
      })
      return status ? this.translate("invoice.validation_statuses." + status.title) : ""
    },
    sum_in_rub(){
      return (this.invoice_info.sum_with_vat / 100).toFixed(2)
    },
  },

  watch: {
    invoice(){
      this.invoice_info = JSON.parse(JSON.stringify(this.invoice))
    }
  },

  methods: {
    download_details(){
      this.$http.v1.downloadDetails(this.invoice_info.id, (response) => {
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(response.data)
        link.download = `Детализация #${this.invoice_info.id} от ${this.get_date(Math.round(+new Date() / 1000))}.xlsx`
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
    },
    getPeriodBounds(period) {
      const [year, month] = String(period).split('-').map(Number);
      const lastDay = new Date(year, month, 0).getDate();

      const mm = String(month).padStart(2, '0');

      return {
        start: `${year}-${mm}-01`,
        end: `${year}-${mm}-${String(lastDay).padStart(2, '0')}`,
        daysCount: lastDay,
      };
    },

    isPeriodStartMatch(period, date) {
      return this.getPeriodBounds(period).start === date;
    },

    isPeriodEndMatch(period, date) {
      return this.getPeriodBounds(period).end === date;
    },

    isPeriodDaysCountMatch(period, days) {
      return this.getPeriodBounds(period).daysCount === Number(days);
    },
    modal_issue_invoice(){
      let t = this.$createElement(IssueAnInvoice, {
        props: {},
        on: {
          close: () => {
            this.$modal.hide('issue_an_invoice_modal')
          },
          update: (params) => {
            this.issue_invoice(params)
            this.$modal.hide('issue_an_invoice_modal')
          }
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        name: 'issue_an_invoice_modal'
      })
    },
    issue_invoice(params) {
      this.$http.v1.putSetIssued(this.invoice_info.id, params, (response) => {
        this.global_notify('info', this.translate('invoice.saved_success'))
        this.invoice_info = response.data
        this.$emit('update')
      })
    },
    get_payment_status(status_id){
      let state = this.$store.getters.getClientInvoicesInfo.payment_statuses.find((status) => {
        if (status_id === status.id){
          return status
        }
      })
      return state ? state : null
    },
    edit_details(details){
      let t = this.$createElement(EditDetails, {
        props: {
          details: details
        },
        on: {
          close: () => {
            this.$modal.hide('edit_details')
          },
          update: () => {
            this.$emit('update')
            this.$modal.hide('edit_details')
          },
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        name: 'edit_details'
      })
    },
    open_copy_settings(){
      let t = this.$createElement(CopySettings, {
        props: {},
        on: {
          close: () => {
            this.$modal.hide('copy_settings_modal')
          },
          copy: (settings) => {
            this.copy_info_in_buffer(settings)
            this.$modal.hide('copy_settings_modal')
          }
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        name: 'copy_settings_modal'
      })
    },
    copy_info_in_buffer(settings){
      let devices = [...this.invoice_info.devices]
      if (settings.sort_by_fid){
        devices.sort((a, b) => a.device_fid > b.device_fid ? 1 : -1)
      }

      let string = ""
      devices.forEach((device, key) => {
        if (settings.skip_zero && Number(device.sum_with_vat) === 0) return

        if (settings.date_transform){
          string += `${this.date_transform(device.period_start, ".")} ${this.date_transform(device.period_end, ".")}\t`
        }else{
          string += `${device.period_start} ${device.period_end}\t`
        }

        string += `${device.device_fid} ${device.device_name}\t`

        if (settings.use_order){
          string += `${device.order}\t`
        }

        string += `${device.service_title}\t`

        let price = Number(device.price_without_vat)
        let price_with_vat = Number(device.price_with_vat)
        if (settings.replace_dot){
          price = price.toString().replace(".", ",")
          price_with_vat = price_with_vat.toString().replace(".", ",")
        }
        string += `${price}\t`
        string += `${price_with_vat}\t`

        if (settings.add_days){
          string += `${device.period_days}\t`
        }

        let cost = Number(device.sum_without_vat)
        let cost_with_vat = Number(device.sum_with_vat)
        let vat_amount = Number(device.vat_amount)
        if (settings.replace_dot){
          cost = cost.toString().replace(".", ",")
          cost_with_vat = cost_with_vat.toString().replace(".", ",")
          vat_amount = vat_amount.toString().replace(".", ",")
        }
        string += `${cost}\t`
        string += `${cost_with_vat}\t`
        string += `${vat_amount}\t`

        if (key !== this.invoice_info.devices?.length - 1){
          string += `\r`
        }
      })
      this.copy_to_clipboard(string);
      this.global_notify("info", this.translate("clipboard.value_save_buffer"));
    },
    edit_invoice() {
      let invoice_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.invoice_info[key];
        return obj;
      }, {});

      this.$http.v1.updateInvoice(this.invoice_info.id, invoice_info, (response) => {
        this.global_notify('info', this.translate('invoice.saved_success'))
        this.invoice_info = response.data
        this.$emit('update')
      })
    },
    update_invoice_status(status) {
      this.$http.v1.updateInvoiceValidationStatus(this.invoice_info.id, {validation_status: status}, (response) => {
        this.global_notify('info', this.translate('invoice.saved_success'))
        this.invoice_info = response.data
        this.$emit('update')
      })
    },
  }
}

</script>

<style lang='scss' scoped>
.invoice_info {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  overflow: auto;

  @media (max-width: 991px) {
    flex-direction: column;
  }

  &__left {
    width: 70%;
    height: 100%;
    padding-right: 10px;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }

    .form_select{
      .form-control {
        width: 100%;
      }
    }

    .response_table {
      height: auto;
      padding: 0;
      margin-bottom: 10px;
      &:last-child{
        margin-bottom: 0;
      }

      .table_header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 5px;

        .buttons{
          display: flex;
          gap: 10px;

        }

        label{
          margin-bottom: 0;
        }
      }

      table {
        td {
          padding: 5px;
          &.good_sum{
            background-color: rgba(55, 255, 0, 0.34);
          }
          p{
            font-size: 12px;
            margin-bottom: 0;
          }
        }
        .device_item{
          .mdi-pen{
            font-size: 14px;
            cursor: pointer;
          }
          .not_match, .not_full_cost{
            background-color: #F3BB45;
          }
          span.mdi{
            font-size: 14px;
            &.tariffication{
              color: #3f93d3;
            }
          }
        }
        .prev_invoice{
          &__item{
            color: #66615b;
            &:hover{
              background-color: #eaeaea;
            }
          }
        }
      }
      &.invoice_details{
        th, td{
          overflow-wrap: anywhere;
        }
        @each $width in 2, 3, 4, 7, 8, 10, 14{
          .w#{$width}per{
            width: $width * 1%;
          }
        }
      }
      .w70{
        width: 70px;
      }
      .w30{
        width: 30px;
      }
    }

    .buttons {
      margin-top: 10px;
      .btn{
        margin-right: 10px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }

  &__right {
    width: 30%;
    height: 100%;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }
  }
}
</style>
